import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Col, Container} from 'react-bootstrap'
import { useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { formato_monto } from '../../common/Formatos'

const Grilla = () => {
  const [show, setShow] = useState(false) 
const [listaGrilla,setListaGrilla]= useState('') 
  const data_ingreso = useSelector((state) => state.ingresoRecobroReducer)
   const { cfg_form35, datosRecobro} = data_ingreso

 useEffect(()=>{
  setListaGrilla(datosRecobro && datosRecobro.datosRecobro.recobros)
 },[datosRecobro])
 useEffect(()=>{
  setListaGrilla('')
 },[])
 const obtenerColumnas = () => {
  return [
    
    
    {
      dataField: 'nroAviso',
      text:cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-aviso'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'fecIngresoCajaFormat',
      text: cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-fechacaja'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'glosaMonedaPago',
      text: cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-moneda'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'montoPago',
      text:cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-mtorecobro'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' },
      formatter: (cell, row) => {
        return formato_monto(cell);
      }
    },
    {
      dataField: 'responsableIngreso',
      text: cfg_form35 ?cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-respingreso'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'responsableGestion',
      text: cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-respgestion'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    {
      dataField: 'girador',
      text: cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-girador'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    {
      dataField: 'glosaEstado',
      text: cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-estado'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    {
      dataField: 'fechaVisado',
      text: cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-fechavisado'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    {
      dataField: 'visador',
      text: cfg_form35 ? cfg_form35.cfg_form35[
        'modalconsultarecobros-grilla-visador'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form35 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
   
   
  ]
}

  return (
    <>
     
      <Container>
      
      <Row className='mt-4 mb-3'>
          <Col>
            <ToolkitProvider
                search
                bootstrap4
                keyField='id'
                data={listaGrilla ? listaGrilla : []}
                columns={obtenerColumnas()}
                defaultSorted={[{ dataField: 'id', order: 'asc' }]}
               
                >
                {(props) => (
                    <div>
                   

                    <BootstrapTable
                        {...props.baseProps}
                        bordered={false}
                        headerWrapperClasses='table-secondary'
                        pagination={paginationFactory({ sizePerPage: 5})}
                        noDataIndication={
                        <div className='text-center'>
                            No hay registros encontrados
                        </div>
                        }
                    />
                    </div>
                )}
            </ToolkitProvider>
          </Col>
      </Row>
       
      </Container>
    </>
  )
}

export default Grilla
